"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initCustomProgram = exports.initPredefinedProgram = exports.readActiveProgram = exports.readSystemSettings = exports.write = exports.read = exports.customDurations = void 0;
const bluetooth_le_1 = require("@capacitor-community/bluetooth-le");
const c = __importStar(require("./constants"));
const neorhythm_utils_1 = require("./neorhythm-utils");
// Custom durations: 10-720 min mod 10
exports.customDurations = () => new Array(720 / 10).fill(1).map((_, i) => (i + 1) * 10);
async function read(deviceId) {
    return bluetooth_le_1.BleClient.read(deviceId, c.NEORHYTHM_SERVICE, c.NEORHYTHM_CHARACTERISTIC);
}
exports.read = read;
async function write(deviceId, cmd) {
    return bluetooth_le_1.BleClient.write(deviceId, c.NEORHYTHM_SERVICE, c.NEORHYTHM_CHARACTERISTIC, cmd);
}
exports.write = write;
async function readSystemSettings(deviceId) {
    const system = neorhythm_utils_1.getSystemSetting();
    await write(deviceId, system);
    const res = await read(deviceId);
    return neorhythm_utils_1.decodeSystemSetting(res);
}
exports.readSystemSettings = readSystemSettings;
async function readActiveProgram(deviceId) {
    const program = neorhythm_utils_1.getCurrentProgram();
    await write(deviceId, program);
    const res = await read(deviceId);
    const pre = neorhythm_utils_1.decodePredefinedProgram(res);
    if (pre)
        return Object.assign(Object.assign({}, pre), { type: 'predefined' });
    const custom = neorhythm_utils_1.decodeCustomProgram(res);
    if (custom)
        return Object.assign(Object.assign({}, custom), { type: 'custom' });
    return null;
}
exports.readActiveProgram = readActiveProgram;
async function initPredefinedProgram(deviceId, config) {
    const commands = neorhythm_utils_1.setPredefinedProgram(config);
    if (!commands)
        return null;
    const { programDataView, durationDataView, endDataView } = commands;
    await write(deviceId, programDataView);
    await write(deviceId, durationDataView);
    await write(deviceId, endDataView);
    // return readActiveProgram(deviceId)
}
exports.initPredefinedProgram = initPredefinedProgram;
async function initCustomProgram(deviceId, config) {
    const commands = neorhythm_utils_1.setCustomProgram(config);
    if (!commands)
        return null;
    const { programDataView, endDataView } = commands;
    await write(deviceId, programDataView);
    await write(deviceId, endDataView);
}
exports.initCustomProgram = initCustomProgram;
//# sourceMappingURL=neorhythm-parsers.js.map